import {
	Component, OnInit, ViewChild, HostListener, PLATFORM_ID, Inject, OnDestroy,
	AfterViewInit, ViewChildren, ElementRef, QueryList, inject, NgZone, signal, effect, viewChild
} from '@angular/core';
import { MainService } from '../../main.service';
import { CmsPageSeoService } from '../../services/cms-page-seo.service';
import { Experience } from 'src/app/services/experience.service';
import { NavigationStart, NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { CartService } from 'src/app/services/cart.service';
import { AddExperience } from 'src/app/services/AddExperience.service';
import { ExperienceBookingService } from 'src/app/services/ExperienceBooking.service';
import { LocationService } from 'src/app/services/location.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FindCouple } from 'src/app/services/findcouple.service';
import { MessageService } from '../../message.service';
import { HomeService } from 'src/app/services/Home.service';
import * as globalConstant from '../../global_constant';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DatepickerDateCustomClasses, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { Location } from '@angular/common';
import { SharedModule } from '../../share/shared.module';
import { ToastrService } from 'src/app/services/toastr.service';
import { FilterService, SelectItemGroup } from 'primeng/api';
import { CanonicalService } from 'src/app/services/canonical.service';
import { filter } from 'rxjs/operators';
import { NotFoundComponent } from '../not-found/not-found.component';
import { ExpCardsComponent } from '../exp-cards/exp-cards.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HighLevelCategoryBridgeService } from "src/app/services/HighLevelCategoryBridge.service";
import { ListingPageFooter } from '../listing-page-footer/listing-page-footer.component';
import { ExperienceFaqService } from 'src/app/services/experience-faq.service';
import { SsrStatusService } from 'src/app/services/ssr-status.service';


@Component({
	selector: 'app-high-level-category',
	standalone: true,
	imports: [
		SharedModule,
		NotFoundComponent,
		ListingPageFooter,
		ExpCardsComponent,
	],
	templateUrl: './high-level-category.component.html',
	styleUrls: ['./high-level-category.component.css'],
	// host: { ngSkipHydration: 'true' }
})
export class HighLevelCategoryComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild('videoElement', { static: false }) videoElement: ElementRef;
	@ViewChild('buymodal', { static: false }) public buymodal: ModalDirective;
	@ViewChildren('allExperiences') allExperienceLoad: QueryList<any>;
	//@ViewChild(PlyrComponent, { static: true })
	private _picker: BsDatepickerDirective;
	//plyr: PlyrComponent;
	//player: Plyr;
	breadcrumbs: Array<{ label: string, url: string, path: any }> = [];
	loading: boolean = false;
	isBrowser: boolean;
	category_data: any;
	experienceFaqs: Array<{ id?: number; question: string; answer: string }> = [];
	category_image_url = '';
	categoryList: any;
	slug = '';
	section_image_url = '';
	exp_data: any = [];
	catList: any;
	token = '';
	authUser: any;
	total_exp: any;
	purchaseExpID: any;
	purchaseExpSlug: any;
	purchaseExpTitle: any;
	purchaseExpImage: any;
	purchaseExpType: any;
	purchaseExpPrice: any;
	purchaseExpQuantity: any;
	purchaseExpVerID: any;
	purchaseExpTax: any;
	location_travel: '';
	stateList: any;
	selected_location = '';
	price_filter_search: any = [];
	price_option: any[] = [];
	badge_id: any = '';
	slug_selected = '';
	amount_value: any = '';
	category_name = '';
	//selectedtime:any='';
	selected_people: any = '';
	//time_table_list = time_table_list;
	isUserLogin: boolean = false;
	showRegChkmark: boolean = false;
	page: number = 1;
	last_page: number = 0;
	totalRecord: number = 0;
	current_page: number = 0;
	clickCart: any = "";
	certificate_data: any = '';
	scrollEnable: boolean = false;
	base_url: any = '';
	country_List: any = [];
	state_List: any = [];
	city_List: any = [];
	country_id: any = '';
	state_id: any = '';
	city_id: any = '';
	default_country_id = globalConstant.default_country;
	default_country_name: any = {};
	max_quantity_count: any = 10
	is_booking: number = 0;
	subscription: Subscription;
	dateCustomClasses: DatepickerDateCustomClasses[];
	minDate = new Date();
	maxDate: Date
	selected_date = '';
	start_date: any = '';
	end_date: any = '';
	type = '';
	search_id = '';
	autocomplete_search: string;
	autocomplete_location_search: string = "";
	locationAutocompleteList: any = [];
	autocompleteExpResults: any = [];
	save_filter_event: any = "";
	autocompleteData: any = [];
	modelChanged: Subject<any> = new Subject<any>();
	modelChanged2: Subject<any> = new Subject<any>();
	public fields: Object = { groupBy: 'category', value: 'value' };
	is_offset: any = '';
	exp_pos: any = '';
	at_home: boolean = false;
	searchedItem: any;
	order_by: any = '';
	order: any = '';
	isDataLoading: boolean = false;
	siteUrl: String = globalConstant?.WEBSITE_URL;
	private readonly ssrStatus = inject(SsrStatusService);
	private pageNotFoundState = false;
	get pageNotFound(): boolean {
		return this.pageNotFoundState;
	}
	set pageNotFound(value: boolean) {
		this.pageNotFoundState = value;
		if (value) {
			this.ssrStatus.notFound();
		}
	}
	/** False until category + first listing payload applied (SSR resolver or client fetch). */
	isPageReady = false;
	filterCountries: any[] = [];
	filterCategories: any[] = [];
	filterHighLevel: any[] = [];
	private skipInitialCategoryDetailFetch = false;
	searchHistory: any[] = [];
	searchHistorySave: any[] = [];
	isCookies: boolean;
	experienceList = signal<any[]>([]);
	certificateList = signal<any[]>([]);
	country_slug: string;
	param_country_slug = '';
	state_slug: string;
	groupedData: any[] = [];
	filteredGroups: any[] = [];
	Query: any;
	pageUrl: any = '';
	gridView: boolean = true;
	isMobileView: any;
	@ViewChildren('videoElement') videos!: QueryList<ElementRef<HTMLVideoElement>>;
	observer!: IntersectionObserver;
	isHighLevelCategoryPage: boolean = true;
	categorySlug: any = '';
	breakpoints = {
				0: {
			slidesPerView: 2.2 ,
			spaceBetween: 10
		},
		575: {
			slidesPerView: 3,
			spaceBetween: 10
		},
		768: {
			slidesPerView: 4,
			spaceBetween: 12
		},
		992: {
			slidesPerView: 5,
			spaceBetween: 12
		}
	};
	showCategoryCarouselControls = false;

	swiperEl = viewChild<ElementRef>('swiperEl');

	@HostListener('window:resize')
	onWindowResize() {
		this.updateCategoryCarouselControls();
	}
	// @HostListener('window:scroll', [])
	// onWindowScroll() {
	// 	if (this.isBrowser) {
	// 		var windowScrollTop = (document.documentElement.scrollTop || document.body.scrollTop);
	// 		if (this.scrollEnable && this.isDataLoading === false) {
	// 			if (windowScrollTop > (document.documentElement.scrollHeight - window.innerHeight) - 70) {
	// 				if (this.page <= this.last_page) {
	// 					const url = '/experience/' + [this.slug, this.country_slug, this.state_slug]
	// 						.filter(Boolean)
	// 						.join('/');
	// 					this._location.replaceState(url + "?date=" + this.selected_date + "&page=" + this.page + "&exp_pos=" + ((this.page * 9) - 5) + "&is_booking=" + this.is_booking);
	// 					this.is_offset = 0;
	// 					this.getAllExperienceData();
	// 				}
	// 			}
	// 		}
	// 	}
	// };
	pageTitle: string = '';
	exploreHeading: string = '';
	selectedLocSlug: string = '';

	constructor(
		private bridgeService: HighLevelCategoryBridgeService,
		private experienceService: Experience,
		private activatedRoute: ActivatedRoute,
		private mainService: MainService,
		private experienceFaqService: ExperienceFaqService,
		private cmsPageSeoService: CmsPageSeoService,
		private canonicalService: CanonicalService,
		private router: Router,
		private cartService: CartService,
		public toastr: ToastrService,
		private homeService: HomeService,
		private addexperience: AddExperience,
		private messageService: MessageService,
		private experienceBookingService: ExperienceBookingService,
		public locationService: LocationService,
		public findCoupleService: FindCouple,
		private titleService: Title,
		private metaService: Meta,
		private _location: Location,
		private filterService: FilterService,
		private ngZone: NgZone,
		private breakpointObserver: BreakpointObserver,
		@Inject(DOCUMENT) private dom: Document,
		@Inject(PLATFORM_ID) platformId: Object
	) {
		let currenturl = this.router.url;
		let componentUrl = currenturl.startsWith('/') ? currenturl.slice(1) : currenturl;
		const canonicalUrl = this.normalizeUrl(this.siteUrl + componentUrl);
		this.pageUrl = this.canonicalService.setCanonical(canonicalUrl);
		this.breakpointObserver
			.observe([Breakpoints.Handset])
			.subscribe(result => {
				this.isMobileView = result.matches;
				this.gridView = !this.isMobileView
			});

		this.isBrowser = isPlatformBrowser(platformId);

		effect(() => {
			this.at_home = this.bridgeService.at_home();
			this.page = this.bridgeService.page();
			// this.last_page = this.bridgeService.last_page();
			// this.current_page = this.bridgeService.current_page();
			this.type = this.bridgeService.type();
			this.search_id = this.bridgeService.search_id();
			// this.price_filter_search = this.bridgeService.price_filter_search();
			this.price_option = this.bridgeService.price_filter_search() || [];
			this.exp_data = this.bridgeService.exp_data();
			this.slug = this.bridgeService.slug();
			this.selected_location = this.bridgeService.selected_location();
			this.country_slug = this.bridgeService.countrySlug();
			this.state_slug = this.bridgeService.state();
			this.categorySlug = this.bridgeService.categorySlug();
		});

		if (this.isBrowser) {
			this.base_url = location.origin + '/experiences/';
			if (sessionStorage.getItem('selected_loc_slug')) {
				this.selectedLocSlug = sessionStorage.getItem('selected_loc_slug');
			}
		}

		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe(() => {
			this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
		});


		this.router.routeReuseStrategy.shouldReuseRoute = () => false;

		// Same as location-region: set prev/next in constructor (before NavigationEnd stub cleanup)
		// so SSR updates the index.html link nodes instead of recreating them after removal.
		this.applyPaginationStateFromUrl();
		this.setPaginationLinks();

		if (this.isBrowser) {
			window.scrollTo(0, 0);
			if (localStorage.getItem('authUser')) {
				this.token = localStorage.getItem('login_token');
				this.authUser = JSON.parse(localStorage.getItem('authUser'));
				this.isUserLogin = true;
			}
			else {
				this.token = ''
				this.isUserLogin = false
			}

			// const currentNav = this.router.getCurrentNavigation();
			// const previousUrl = currentNav?.previousNavigation?.finalUrl?.toString() || '';
			// console.log(previousUrl, 'previousUrl');
			// if (previousUrl.includes('/experiences/')) {
			// 	const savedTab = sessionStorage.getItem('active_booking_tab');
			// 	if (savedTab !== null) {
			// 		this.is_booking = parseInt(savedTab, 10);
			// 	}
			// } else {
			// 	sessionStorage.removeItem('active_booking_tab');
			// 	this.is_booking = 0;
			// 	this.bridgeService.setIsBooking(this.is_booking);
			// }

			// const currentNav = this.router.getCurrentNavigation();
			// const previousUrl = currentNav?.previousNavigation?.finalUrl?.toString() || '';

			// // Detect if the user explicitly reloaded/refreshed this page
			// const navigationEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
			// const isReload = navigationEntry?.type === 'reload';

			// if (isReload || previousUrl.includes('/experiences/')) {
			// 	// Retain the tab state if it's a page reload OR coming back from a detail page
			// 	const savedTab = sessionStorage.getItem('active_booking_tab');
			// 	this.is_booking = savedTab ? parseInt(savedTab, 10) : 0;
			// 	this.bridgeService.setIsBooking(this.is_booking);
			// } else {
			// 	// Clear it completely if navigating from Home, another page, or entering fresh
			// 	sessionStorage.removeItem('active_booking_tab');
			// 	this.is_booking = 0;
			// 	this.bridgeService.setIsBooking(this.is_booking);
			// }
		}

		const now = new Date();
		this.dateCustomClasses = [
			{ date: now, classes: ['bg-warning'] },
		];

		this.modelChanged.pipe(debounceTime(100)).subscribe(sub => {
			if (sub.text.replace(/^\s+|\s+$/gm, '').length >= 3)
				this.onFiltering_after_debounce(sub);
		});

		this.modelChanged2.pipe(debounceTime(100)).subscribe(query => {
			if (query.trim().length >= 1) {
				this.onFilteringAfterDebounce(query);
			}
		});

	}

	normalizeUrl(url: string): string {
		return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
	}

	ngOnInit() {
		const listingSeo = this.activatedRoute.snapshot.data['listingSeo'];
		if (listingSeo) {
			this.skipInitialCategoryDetailFetch = this.applyListingSeoFromResolver(listingSeo);
		}

		this.activatedRoute.params.subscribe(params => {
			if (params['slug']) {
				this.slug = params['slug'] || '';
				this.bridgeService.setSlug(this.slug);
			}
			this.ensureRouteSlug();
			if (params['page']) {
				const pageParam = params['page'];
				this.page = parseInt(pageParam.replace('page-', ''), 10) || 1;
				this.bridgeService.setPage(this.page);
			}
			if (params['country']) {
				this.country_slug = params['country'] || '';
				this.bridgeService.setCountrySlug(this.country_slug);
			}
			if (params['state']) {
				this.state_slug = params['state'] || '';
				this.bridgeService.setState(this.state_slug);
			}

			if (this.state_slug) {
				this.selected_location = this.state_slug;
			} else if (this.country_slug) {
				this.selected_location = this.country_slug;
			} else {
				this.selected_location = '';
			}
			this.bridgeService.setSelectedLocation(this.selected_location);

			if (this.skipInitialCategoryDetailFetch) {
				this.skipInitialCategoryDetailFetch = false;
				this.loadChildCategoryList();
				if (this.isBrowser && this.token) {
					// Resolver listing has no registry/bucket status; refresh with login token.
					this.getAllExperienceData(true);
				}
			} else {
				this.getCategoryDetail();
			}
			this.setPaginationLinks();
		});

		this.activatedRoute.queryParams.subscribe(params => {
			const hasQueryParams = Object.keys(params).length > 0;
			if (params['badge_id'] != null && params['badge_id'] !== '') {
				this.badge_id = !isNaN(+params['badge_id']) ? +params['badge_id'] : params['badge_id'];
			}
			if (params['page']) {
				this.page = parseInt(params['page']);
				this.page === 0 ? this.bridgeService.setPage(1) : this.bridgeService.setPage(this.page);
				this.is_offset = 1;
			}
			if (params['start_date']) {
				this.start_date = params['start_date'];
				this.selected_date = this.start_date;
			}
			if (params['end_date']) {
				this.end_date = params['end_date'];
			}
			if (params['date'] && !this.start_date) {
				this.start_date = params['date'];
				this.end_date = params['date'];
				this.selected_date = params['date'];
			}
			if (params['is_booking']) {
				this.is_booking = parseInt(params['is_booking']);
			} else if (this.start_date || this.end_date) {
				this.is_booking = 1;
			}
			if (params['order_by']) {
				this.order_by = params['order_by'];
				this.order = params['order'] || this.order || '';
			}
			if (params['exp_pos']) {
				this.exp_pos = parseInt(params['exp_pos']);
				this.is_offset = 1;
			}
		});
	}

	loadChildCategoryList(): void {
		this.isCookies = this.getCookie('acceptCookies') !== "";
		const category_slug_for_experience = { category_for: 'experience', type: 'higher-level-category' };
		this.mainService.get_categories(category_slug_for_experience).subscribe(res => {
			this.catList = res.data;
			const apiResponse = this.catList || [];
			const targetSlug = this.slug || '';

			const isSlugValid = apiResponse.some(parent => {
				if (parent.slug === targetSlug) {
					return true;
				}
				if (parent.child_categories && parent.child_categories.length > 0) {
					return parent.child_categories.some(child => child.slug === targetSlug);
				}
				return false;
			});

			if (!isSlugValid && !this.category_data) {
				this.pageNotFound = true;
				this.isPageReady = true;
				return;
			}

			for (let i = 0; i < this.catList.length; i++) {
				if (this.catList[i].slug == this.slug && this.catList[i].child_categories && this.catList[i].child_categories.length > 0) {
					this.categoryList = this.catList[i].child_categories;
					this.updateCategoryCarouselControls();
					break;
				}
			}
		});
	}

	/** Apply data prefetched by listingSeo resolver (SSR + first paint). Returns true to skip duplicate detail fetch. */
	private applyListingSeoFromResolver(data: any): boolean {
		if (!data) {
			return false;
		}
		const { categoryRes, listingRes, faqs } = data;
		this.filterCountries = Array.isArray(data.filterCountries) ? data.filterCountries : [];
		this.filterCategories = Array.isArray(data.filterCategories) ? data.filterCategories : [];
		this.filterHighLevel = Array.isArray(data.filterHighLevel) ? data.filterHighLevel : [];
		if (categoryRes?.response !== 'success') {
			this.pageNotFound = true;
			this.isPageReady = true;
			return true;
		}

		this.category_data = categoryRes.data;
		this.category_image_url = categoryRes?.image_url;
		this.category_name = categoryRes.data?.name;
		this.pageNotFound = false;

		if (listingRes?.response === 'success') {
			this.applyCategoryListingResponse(listingRes, false);
		}

		this.experienceFaqs =
			faqs?.response === 'success' && Array.isArray(faqs?.data) ? faqs.data : [];

		this.addMetaTags();
		this.updateListingSchema();
		this.setPaginationLinks();
		this.isPageReady = true;
		return true;
	}

	private applyCategoryListingResponse(res: any, incrementPageAfterFetch = true): void {
		if (res.response != 'success') {
			return;
		}
		this.isDataLoading = false;
		const responseData = res.data.data;
		this.certificate_data = res.certificate_data;
		this.certificateList.set(res.certificate_data);

		for (let i = 0; i < responseData.length; i++) {
			if (responseData[i].variations_data.length > 0) {
				for (let k = 0; k < responseData[i].variations_data.length; k++) {
					if (responseData[i].variations_data[k].slug == 'buy-for-yourself') {
						responseData[i].is_buy_for_yourself = 1;
						responseData[i].buy_for_yourself_veriation_id = responseData[i].variations_data[k].id;
						break;
					} else {
						responseData[i].is_buy_for_yourself = 0;
						responseData[i].buy_for_yourself_veriation_id = 0;
					}
				}
			} else {
				responseData[i].is_buy_for_yourself = 0;
				responseData[i].buy_for_yourself_veriation_id = 0;
			}
		}

		this.exp_data = responseData;
		this.experienceList.set(this.exp_data);
		this.getExpQuantity(this.exp_data);
		this.updateListingSchema();
		this.totalRecord = res?.data?.total;
		this.total_exp = Object.keys(this.exp_data).length;
		this.loading = false;
		this.last_page = res.data.last_page;
		this.current_page = res.data.current_page + 1;
		if (incrementPageAfterFetch) {
			this.page = this.page + 1;
		}
		this.scrollEnable = true;
	}

	getCategoryDetail() {

		this.loadChildCategoryList();

		let requestBody = {
			'slug': this.slug,
			'location_slug': this.selected_location,
			'type': 'higher-level-category'
		};

		this.experienceService.getcategoryDetail(requestBody).subscribe(res => {
			if (res.response == 'success') {
				this.category_data = res.data;
				if (this.isCookies && this.category_data.id !== undefined && this.category_data.id !== null) {
					const newSearch = {
						id: this.category_data?.id,
						title: this.category_data.name,
						image_url: this.category_data?.image_url,
						params: this.category_data?.slug,
						city: '',
						type: this.category_data?.type,
						location_type: '',

					};
					this.saveRecentSearch(newSearch);
				} else if (this.isCookies && !this.category_data.id) {
					if (this.isBrowser) {
						const searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
						this.searchHistorySave = searchHistory;
					}
				}
				this.category_name = res.data.name;
				this.category_image_url = res?.image_url;
				this.pageNotFound = false;
				if (this.videoElement && this.videoElement.nativeElement) {
					this.videoElement.nativeElement.load(); // play video
				}

				this.addMetaTags();
				this.loadExperienceFaqs();

				this.getAllExperienceData(); // calls function for get experiences data.
			} else {
				this.pageNotFound = true;
				this.isPageReady = true;
			}
		});
	}

	markPageNotFound(): void {
		this.pageNotFound = true;
	}

	loadExperienceFaqs(): void {
		const categoryId = this.category_data?.id;
		if (!categoryId) {
			this.experienceFaqs = [];
			return;
		}
		this.experienceFaqService.listByEntity({ category_id: categoryId }).subscribe((res) => {
			this.experienceFaqs = res?.response === 'success' && Array.isArray(res?.data) ? res.data : [];
			this.updateListingSchema();
		});
	}

	getCookie(data) {
		if (this.isBrowser) {
			let name = data + "=";
			let ca = document.cookie?.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}
	}

	saveRecentSearch(newSearch) {
		if (this.isBrowser) {

			let searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
			if (newSearch?.id !== null) {
				searchHistory = searchHistory.filter(exp => exp?.title !== newSearch?.title);
			} else {
				searchHistory = searchHistory.filter(exp => !(exp.id === newSearch?.id && exp?.type === newSearch?.type));
			}

			// Add the new search entry to the top
			if (Object.keys(newSearch)?.length > 0) {
				searchHistory.unshift(newSearch);
			}
			// Ensure only the last 5 experiences are stored
			if (searchHistory?.length > 5) {
				searchHistory = searchHistory.slice(0, 5);
			}

			this.searchHistorySave = searchHistory;
			localStorage.setItem('searchHistory', JSON.stringify(this.searchHistorySave));
		}
	}

	tab_change(is_booking = 0) {
		if (this.isBrowser) {
			if (this.is_booking == is_booking) {
				return;
			}
			this.is_booking = is_booking;
			this.page = 1;
			this.bridgeService.setPage(this.page);
			this.selected_date = '';
			this.start_date = '';
			this.end_date = '';
			this.current_page = 1;
			this.last_page = 1;
			this.exp_pos = 0;
			this.exp_data = [];
			this.at_home = false;
			this.certificate_data = [];

			const url = '/experience/' + [this.slug, this.country_slug, this.state_slug].filter(Boolean).join('/');

			let queryParams: any = {};
			if (this.is_booking == 1) {
				queryParams.is_booking = this.is_booking
			}
			if (this.start_date) {
				queryParams.start_date = this.start_date
			}
			if (this.end_date) {
				queryParams.end_date = this.end_date
			}
		if (this.badge_id) {
			queryParams.badge_id = String(this.badge_id);
		}
		this.canonicalService.replaceStateWithFilters(this._location, url, queryParams);
			this.getAllExperienceData();
		}
	}

	clearLocationAutocomplete() {
		if (this.is_offset == 0) {
			this.page = 1;
			this.current_page = 1;
			this.last_page = 1;
		} else {
			this.current_page = 0;
			this.last_page = 0;
		}
		this.selected_location = '';
		this.getAllExperienceData();
	}

	autocompleteLocationSearchOnly(event) {

		let requestBody = { 'search': event.query };

		this.locationService.locationAutocomplete(requestBody).subscribe(res => {
			if (res.response == 'success') {
				this.locationAutocompleteList = res.data;

			} else {
				this.locationAutocompleteList = [];
			}
		});
	}

	onSelectAutocompleteLocationOnly(event) {
		switch (event.value.type) {
			case "location":
				this.selected_location = event.value.id;
				if (this.is_offset == 0) {
					this.page = 1;
					this.current_page = 1;
					this.last_page = 1;
				} else {
					this.current_page = 0;
					this.last_page = 0;
				}
				this.getAllExperienceData();
				break;
		}
	}

	getAllExperienceData(keepVisible = false) {

		this.readUrl();
		// if ((this.last_page >= this.page || this.last_page == 0) && this.current_page <= this.last_page) {
		// this.loading	=	true;
		if (!keepVisible) {
			this.isDataLoading = true;
			this.totalRecord = 0;
		}
		let request_Body = {
			'booking_date': this.start_date || this.selected_date,
			'booking_people': this.selected_people,
			'location_slug': this.selected_location,
			'price_option': this.price_option,
			'badge_id': this.badge_id || '',
			'category_slug': this.categorySlug ? this.categorySlug : this.slug,
			'category_type': 'higher-level-category',
			'page': this.page,
			'is_booking': this.is_booking,
			'search_id': this.search_id,
			'type': this.type,
			// 'is_offset': this.is_offset,
			'at_home': this.at_home,
			'title': this.searchedItem,
			'order_by': this.order_by,
			'order': this.order,
		};
		this.experienceService.getExperienceByCategoryPagination(request_Body, this.token).subscribe(res => {
			if (keepVisible && res?.response != 'success') {
				return;
			}
			if (res.response == 'success') {
				this.updateUrlParams();
				this.addMetaTags();
				this.applyCategoryListingResponse(res, true);
				setTimeout(() => {
					this.scrollToSelectedExperience();
				}, 300);
			}
			else if (res.response == 'error') {
				this.scrollEnable = false;
			}
			this.loading = false;
			this.isDataLoading = false;
			this.isPageReady = true;
		});
		// }
	}

	/* OPEN ADD TO CART FOR NON LOGGEDIN USERS POPUP */
	openDialog(record, price, type, tax = 0, data: any = '', componentName = 'high-level-category') {
		if (data['key']) {
			data['key'] = this.authUser?.role_id == 4 ? ((!record?.for_individual_price || record?.for_individual_price == 0) ? 2 : 1) : data?.key
		}
		//this.close();
		if (record?.is_buy_for_yourself == 1) {

			if (this.isBrowser) {
				var element = document.querySelector("body");
				var htmlelement = document.querySelector("html")
				if (element) {
					element.classList.add('overflow');
				}
				if (htmlelement) {
					htmlelement.classList.add('overflow');
				}
			}

			this.clickCart = "overflow_remove"
			var qty = record.alternate_quantity == 1 ? data?.qty : 1;
			let gratuity = record?.gratuity ? record?.gratuity : 0;
			if (record.alternate_quantity == 1) {
				var taxValue = ((price * qty) * tax / 100);
				var gratuityValue = ((price * qty) * gratuity / 100);
				this.purchaseExpPrice = price;
			} else {
				if (this.isUserLogin && this.authUser?.role_id != 4) {
					var taxValue = ((price * qty) * tax / 100);
					var gratuityValue = ((price * qty) * gratuity / 100);
					this.purchaseExpPrice = price
				} else {
					if (data?.key > 1 && record?.for_individual_price > 0) {
						var taxValue = (((price * data?.key) * qty) * tax / 100);
						var gratuityValue = (((price * data?.key) * qty) * gratuity / 100);
						this.purchaseExpPrice = price * data?.key
					} else {
						var taxValue = ((price * qty) * tax / 100);
						var gratuityValue = ((price * qty) * gratuity / 100);
						this.purchaseExpPrice = price
					}
				}
			}

			this.purchaseExpID = record?.id;
			this.purchaseExpSlug = record?.slug;
			this.purchaseExpTitle = record?.title;
			this.purchaseExpImage = record?.image_url;
			this.purchaseExpType = type;
			this.purchaseExpVerID = record?.buy_for_yourself_veriation_id;
			this.purchaseExpQuantity = qty;
			this.purchaseExpTax = taxValue;
			let pusheditems = {};
			var cartitems: any = [];
			if (this.isBrowser) {

				if (localStorage.getItem('cart_details')) {
					cartitems = JSON.parse(localStorage.getItem('cart_details'));
				}
			}
			let hasPresentOn = cartitems.find(
				function (el) {
					if (el.product_id === record?.id) {
						return true;
					} else {
						return false;
					}
				}
			);
			if (!hasPresentOn) {
				if (this.authUser && (this.authUser.role_id == 5 || this.authUser.role_id == 1)) {
					pusheditems['voucher_name'] = this.authUser.first_name + ' ' + this.authUser.last_name + ' & ' + this.authUser.partner_first_name + ' ' + this.authUser.partner_last_name;
				} else if (this.authUser && this.authUser.role_id == 4) {
					pusheditems['voucher_name'] = this.authUser.first_name + ' ' + this.authUser.last_name
				}
				pusheditems['product_id'] = this.purchaseExpID;
				pusheditems['title'] = this.purchaseExpTitle;
				pusheditems['slug'] = this.purchaseExpSlug;
				pusheditems['image'] = this.purchaseExpImage;
				pusheditems['type'] = this.purchaseExpType;
				pusheditems['line_total'] = this.purchaseExpPrice;
				pusheditems['qty'] = this.purchaseExpQuantity;
				pusheditems['variation_id'] = this.purchaseExpVerID;
				pusheditems['tax'] = this.purchaseExpTax;
				pusheditems['gratuity'] = gratuityValue;
				pusheditems['tax_percentage'] = Number(tax);
				pusheditems['gratuity_percentage'] = Number(gratuity);
				pusheditems['at_home'] = record?.at_home;
				pusheditems['instant_ship'] = record?.instant_ship;
				pusheditems['component_name'] = record?.componentName;
				pusheditems['price_label'] = record?.price_label;
				pusheditems['name_label'] = data?.name ? data?.name : '';
				pusheditems['city'] = record.alternate_quantity == 1 ? record?.city : '';
				pusheditems['state'] = record.alternate_quantity == 1 ? record?.state : '';
				pusheditems['people_count'] = record.alternate_quantity == 1 || data?.key ? data?.key : data;
				pusheditems['alternate_quantity'] = record.alternate_quantity

				if (this.authUser) {
					pusheditems['user_id'] = this.authUser.id;
				}
				else {
					pusheditems['user_id'] = 0;
				}
				pusheditems['clickCart'] = this.clickCart;
				cartitems.push(pusheditems);
				this.cartService.sendMessage(JSON.stringify(cartitems));
				if (this.isBrowser) {
					localStorage.setItem('cart_details', JSON.stringify(cartitems));
				}
			} else {
				this.toastr.errorToastr("Already added in your cart.", 'Error!');
			}

			setTimeout(() => {
				if (this.isBrowser) {
					var popupWrapElement = document.querySelector(".cartpopup-wrap");
					if (popupWrapElement) {
						popupWrapElement.classList.add('active');
					}
				}

			}, 100);
		}
	}

	selected_category(slug, name = "") {
		this.router.navigate(['/experience/' + slug]);
	}

	changePriceFilter(price1, price2, type) {
		this.price_filter_search = [];
		this.amount_value = type;
		this.page = 1;
		this.current_page = 1;
		this.last_page = 1;
		if (type != 'all') {
			var priceArr = { 'lte': price2, 'gte': price1 }
			var checkExist = 0;
			if (this.price_filter_search.length > 0) {
				this.price_filter_search.forEach(function (item, index) {
					if (item.lte == price2 && item.gte == price1) {
						checkExist = 1;
					}
				});
			}
			if (checkExist == 0) {
				this.price_filter_search.push(priceArr);
			}
			setTimeout(() => {
				this.getAllExperienceData();
			}, 500)
		} else {
			setTimeout(() => {
				this.getAllExperienceData();
			}, 500)
		}

	}

	/* selected_time(time)
	{
		this.selectedtime=time;
	} */
	select_people(people) {
		this.selected_people = people;
	}

	submit_search() {
		this.page = 1;
		this.current_page = 1;
		this.last_page = 1;
		this.getAllExperienceData();
	}

	/* FUNCTION TO ADD/REMOVE TO REGISTRY */
	addToRegistry(exp_id, type, index) {
		this.showRegChkmark = true;
		this.exp_data[index].is_show_ckbx = 1;     // show vebo V image.
		this.addexperience.addExperienceRegistry(exp_id, type, this.token).subscribe(res => {
			if (res.response == 'success') {
				this.messageService.sendTotalMessage(res.data);
				this.exp_data[index].is_show_ckbx = 0;    // hide vebo V image.
				this.exp_data[index].experience_status_msg = res.data.experience_status_msg;
				this.exp_data[index].add_reg_msg_class = res.data.add_reg_msg_class;
				this.exp_data[index].added_registry_type = res.data.added_registry_type;
				this.exp_data[index].experience_status = res.data.is_registry_status;
				this.exp_data[index].is_registry_status = res.data.is_registry_status;

			} else if (res.response == 'error') {
			}
		});
	}

	add_gift_certificate() {
		this.router.navigate(['/gift-card']);
	}

	add_gift_event(e) {
		e.is_buy_for_yourself = 1;
		this.router.navigate(['/gift-card']);
	}

	// ----------- home page ------------------------

	ngAfterViewInit() {
		this.allExperienceLoad.changes.subscribe(t => {
			if (this.is_offset == 1 && this.exp_pos > 0) {
				if (this.isBrowser) {
					var element = document.getElementById(this.exp_pos);
					if (element)
						element.scrollIntoView();
				}
			}
		});

		if (this.isBrowser) {
			this.showVideo();
		}
	}

	buildThresholdList() {
		const thresholds = [];
		const numSteps = 20;
		for (let i = 1; i <= numSteps; i++) {
			thresholds.push(i / numSteps);
		}
		return thresholds;
	}

	showVideo() {
		if (this.isBrowser) {
			const options: IntersectionObserverInit = {
				root: null,
				threshold: this.buildThresholdList()
			};

			this.ngZone.runOutsideAngular(() => {
				this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);

				this.videos.forEach(videoRef => {
					const video = videoRef.nativeElement;
					video.preload = 'metadata'; // prevent network overload
					video.pause(); // ensure all are paused initially
					this.observer.observe(video);
				});

				// Also re-evaluate on resize/scroll in case layout shifts
				window.addEventListener('resize', this.recheckObserver);
				window.addEventListener('scroll', this.recheckObserver, true);
			});
		}
	}

	private handleIntersect(entries: IntersectionObserverEntry[]) {
		let maxRatio = 0;
		let mostVisibleVideo: HTMLVideoElement | null = null;

		entries.forEach(entry => {
			const ratio = entry.intersectionRatio;
			if (ratio > maxRatio) {
				maxRatio = ratio;
				mostVisibleVideo = entry.target as HTMLVideoElement;
			}
		});

		if (mostVisibleVideo) {
			this.videos.forEach(videoRef => {
				const video = videoRef.nativeElement;
				if (video === mostVisibleVideo) {
					video.play().catch(() => { });
				} else {
					video.pause();
				}
			});
		}
	}

	private recheckObserver = () => {
		this.videos.forEach(videoRef => {
			const video = videoRef.nativeElement;
			this.observer.unobserve(video);
			this.observer.observe(video);
		});
	};

	select_country(id) {
		if (id) {
			this.selected_location = id;
		}
		this.country_id = id;
		this.state_id = '';
		this.city_id = '';
		this.state_List = [];
		this.exp_data = [];

	}

	onSchedulingDateSelect($event) {
		if (!$event) {
			this.selected_date = '';
			this.page = 1;
			this.bridgeService.setPage(this.page);
			const url = '/experience/' + [this.slug, this.country_slug, this.state_slug, `page-${this.page}`]
				.filter(Boolean)
				.join('/');

			let queryParams: any = {};

			if (this.is_booking == 1) {
				queryParams.is_booking = this.is_booking;
			}

		if (this.badge_id) {
			queryParams.badge_id = String(this.badge_id);
		}
		this.canonicalService.replaceStateWithFilters(this._location, url, queryParams);
			this.getAllExperienceData();
			return;
		}

		this.exp_data = [];
		this.selected_date = '';
		this.page = 1;
		this.bridgeService.setPage(this.page);
		this.current_page = 1;
		this.last_page = 1;
		var counter = 0;
		var year = "" + $event.getFullYear();
		var month = "" + ($event.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
		var day = "" + $event.getDate(); if (day.length == 1) { day = "0" + day; }
		this.selected_date = year + "-" + month + "-" + day
		const url = '/experience/' + [this.slug, this.country_slug, this.state_slug, `page-${this.page}`].filter(Boolean).join('/');
		let queryParams: any = {};
		if (this.is_booking) {
			queryParams.is_booking = this.is_booking
		}
		if (this.selected_date) {
			queryParams.date = this.selected_date
		}
		if (this.badge_id) {
			queryParams.badge_id = String(this.badge_id);
		}
		this.canonicalService.replaceStateWithFilters(this._location, url, queryParams);

		this.getAllExperienceData();
	}

	onDateRangeChange(event: { start_date?: any; end_date?: any }) {
		this.start_date = event?.start_date || '';
		this.end_date = event?.end_date || '';
		this.selected_date = this.start_date;
		this.page = 1;
		this.bridgeService.setPage(this.page);
		this.current_page = 1;
		this.last_page = 1;
		this.exp_data = [];
		this.experienceList.set([]);

		const url = '/experience/' + [this.slug, this.country_slug, this.state_slug].filter(Boolean).join('/');
		let queryParams: any = {};
		if (this.is_booking == 1) {
			queryParams.is_booking = this.is_booking;
		}
		if (this.start_date) {
			queryParams.start_date = this.start_date;
		}
		if (this.end_date) {
			queryParams.end_date = this.end_date;
		}
		if (this.badge_id) {
			queryParams.badge_id = String(this.badge_id);
		}
		this.canonicalService.replaceStateWithFilters(this._location, url, queryParams);
		this.getAllExperienceData();
	}

	onShowPicker(event) {
		if (this.isBrowser) {
			const dayHoverHandler = event.dayHoverHandler;
			const hoverWrapper = (hoverEvent) => {
				const { cell, isHovered } = hoverEvent;
				if ((isHovered &&
					!!navigator.platform &&
					/iPad|iPhone|iPod/.test(navigator.platform)) &&
					'ontouchstart' in window
				) {
					(this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
				}

				return dayHoverHandler(hoverEvent);
			};
			event.dayHoverHandler = hoverWrapper;
		}
	}

	exp_detail(event: Event, slug, exp_pos, request_type = '') {
		event.preventDefault(); // Prevents the default navigation behavior

		//var page_no = this.page;
		var page_no = (this.page == this.last_page) ? this.page + 1 : this.page;
		this.router.navigate(['/experience/' + this.slug], { queryParams: { date: this.selected_date, 'page': (page_no - 1), 'exp_pos': exp_pos, 'is_booking': this.is_booking } })
		setTimeout(() => {
			this.router.navigate(['/experiences/' + slug], { queryParams: { date: this.selected_date, 'page': (page_no - 1), 'request_type': request_type } })
		}, 10)
	}

	autocompleteSearch(event) {
		let requestbody = { 'category_slug': this.slug, 'search': event.query, 'category_type': 'higher-level-category' };
		this.experienceService.getAutocompleteExperienceByCategory(requestbody, this.token).subscribe(res => {
			if (res.response == 'success') {
				this.autocompleteExpResults = res.data;
			}
		});
	}

	search_clear() {
		if (this.search_id != '') {
			this.search_id = '';
			this.type = '';
			this.autocompleteExpResults = [];
			this.exp_data = [];
			this.last_page = 0;
			this.page = 1;
			this.current_page = 0;
			this.getAllExperienceData();
		}
	}

	onSelectAutocompleteExperience(event) {
		this.search_id = event.id;
		this.type = event.type;
		this.exp_data = [];
		this.last_page = 0;
		this.page = 1;
		this.current_page = 0;
		this.getAllExperienceData();
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		if (this.subscription != undefined && this.subscription != null) {
			this.subscription.unsubscribe();
		}
		this.selected_location = "";
	}

	onFiltering(event: any) {
		this.modelChanged2.next(event?.query);
		this.Query = event.query;
	}

	onFiltering_after_debounce(e?) {
		let searchKeyword = e.text.trim();
		let requestbody = { 'category_slug': this.slug, 'search': searchKeyword, 'category_type': 'higher-level-category' };
		this.experienceService.getAutocompleteExperienceByCategory(requestbody, this.token).subscribe(res => {
			if (res.response == 'success') {
				setTimeout(function () {
					this.autocompleteData = res?.data;
					e.updateData(this.autocompleteData);
				}, 10);
			}
		});
	}

	onFilteringAfterDebounce(query: string) {
		const searchKeyword = query.trim();
		let requestbody = { 'category_slug': this.slug, 'search': searchKeyword, 'category_type': 'higher-level-category' };
		this.experienceService.getAutocompleteExperienceByCategory(requestbody, this.token).subscribe(res => {
			if (res.response === 'success') {
				setTimeout(() => {
					this.autocompleteData = res.data;
					this.groupItemsDynamically();
				}, 10);
			}
		});
	}

	groupItemsDynamically() {
		const groups: { [key: string]: any } = {};
		if (this.autocompleteData.length > 0) {

			this.autocompleteData.forEach(item => {
				const groupKey = item.type;
				if (!groups[groupKey]) {
					groups[groupKey] = {
						label: `By ${item.type === 'category' ? 'Category' : 'Name'}`,
						type: item.type,
						items: []
					}
				}
				groups[groupKey].items.push({ id: item.id, value: item.value, label: item.label, type: item.type });
			});
		}
		this.groupedData = Object.values(groups);
		this.filterGroupedCity()
	}

	filterGroupedCity() {
		let query = this.Query
		let filteredGroups = [];

		for (let optgroup of this.groupedData) {
			let filteredSubOptions = this.filterService.filter(optgroup.items, ['label'], query, "contains");
			if (filteredSubOptions && filteredSubOptions.length) {
				filteredGroups.push({
					label: optgroup.label,
					value: optgroup.value,
					items: filteredSubOptions
				});
			}
		}

		this.filteredGroups = filteredGroups;
	}

	at_home_exp(input) {
		this.at_home = input.target.checked;
		this.page = 1;
		this.selected_date = '';
		this.current_page = 1;
		this.last_page = 1;
		this.exp_data = [];
		this.certificate_data = [];
		this.getAllExperienceData();
	}

	getExpQuantity(data) {
		// Generate People Option Dropdown RFP 249.
		if (data?.length > 0) {
			data.forEach((element, i) => {
				let seats = this.max_quantity_count;
				let book_denominator = element.book_denominator;
				let individual_price = element.for_individual_price;
				let people_options = [];
				if (Number(seats) > 0) {
					for (let i = 1; i <= Number(seats); i++) {
						//let personOptions = {};
						if (i == 1) {
							var personName = 'Person';
						} else {
							var personName = 'People';
						}
						// book_denominator = 2 
						if (Number(book_denominator) > 1) {
							if ((Number(i) % Number(book_denominator)) === 0) {
								let pQty = Number(i) / Number(book_denominator);
								people_options.push({ 'key': i, 'value': i + ' ' + personName });
							}

						} else if (Number(individual_price) == 0) {
							if ((Number(i) % 2) === 0) {
								let pQty = Number(i) / 2;
								people_options.push({ 'key': i, 'value': i + ' ' + personName });
							}
						} else {
							people_options.push({ 'key': i, 'value': i + ' ' + personName });
						}
						if (i == 10) {
							break;
						}
					}
				}
				element['book_quantity_options'] = people_options;
				if (element?.price_label_dropdown?.length > 0) {
					element['book_quantity_options'] = element?.price_label_dropdown

				}
			});
		}
		// Check If Booking People selection quantity is allowed on experience end or not.

	}
	addCartQuantity(i, record) {
		var cartitems: any = [];
		if (this.isBrowser) {
			if (localStorage.getItem('cart_details')) {
				cartitems = JSON.parse(localStorage.getItem('cart_details'));
			}
		}

		let hasPresentOn = cartitems.find(
			function (el) {
				if (el.product_id === record?.id) {
					return true;
				} else {
					return false;
				}
			}
		);

		if (!hasPresentOn) {
			for (let i = 0; i < this.exp_data.length; i++) {
				if (this.isBrowser) {
					let element = document.getElementById("select_people_" + i)
					if (element) {
						element.classList.remove("active");
					}
				}
			}
			if (this.isBrowser) {
				let element = document.getElementById("select_people_" + i)
				element.classList.add("active");
			}
		}
		else {
			this.toastr.errorToastr("Already added in your cart.", 'Error!');
		}
	}

	removeClass(i) {
		if (this.isBrowser) {
			let element = document.getElementById("select_people_" + i)
			if (element) {
				element.classList.remove("active");
			}
		}
	}

	addMetaTags() {
		// Helper function to remove special characters and convert to Title Case
		const formatLocation = (val: string | null | undefined): string => {
			if (!val) return '';
			return val
				.replace(/[-_]/g, ' ')
				.replace(/[^a-zA-Z0-9\s]/g, '')
				.toLowerCase()
				.split(/\s+/)
				.map(word => word.charAt(0).toUpperCase() + word.slice(1))
				.join(' ')
				.trim();
		};

		// Fetch and format freshest country and state values from the bridge service
		const country = formatLocation(this.bridgeService.countrySlug());
		const state = formatLocation(this.bridgeService.state());

		const categoryName = (this.category_data?.name || '').trim();
		const headingParts = [];
		if (categoryName) {
			headingParts.push(`Explore ${categoryName} experiences`);
		}
		if (country) headingParts.push(country);
		if (state) headingParts.push(state);
		this.exploreHeading = headingParts.join(' | ');

		// Dynamic SEO from page content + route location (empty when absent)
		const titleParts = [];
		if (categoryName) titleParts.push(categoryName);
		if (country) titleParts.push(country);
		if (state) titleParts.push(state);
		this.pageTitle = titleParts.join(' | ');

		const description = (this.category_data?.seo_description || this.category_data?.description || '').trim();
		const imageUrl = this.category_data?.cover_image_url
			|| this.category_data?.image_url
			|| this.category_data?.og_image
			|| '';

		this.cmsPageSeoService.applyEntitySeo({
			...this.category_data,
			seo_title: '',
			title: this.pageTitle,
			name: this.pageTitle,
			seo_description: description,
			image_url: imageUrl,
		}, {
			pageUrl: this.pageUrl,
			skipSchema: true,
		});

		this.updateListingSchema();
	}

	updateListingSchema(): void {
		const description = (this.category_data?.seo_description || this.category_data?.description || '').trim();
		const imageUrl = this.category_data?.cover_image_url
			|| this.category_data?.image_url
			|| this.category_data?.og_image
			|| '';
		const listing = Array.isArray(this.experienceList?.()) ? this.experienceList() : (this.exp_data || []);
		const siteUrl = (globalConstant.WEBSITE_URL || '').replace(/\/?$/, '/');
		const pageName = this.pageTitle || this.category_data?.name;
		const breadcrumbs: Array<{ name: string; url: string }> = [
			{ name: 'Home', url: siteUrl },
			{ name: 'Experience', url: siteUrl + 'experience' },
		];
		if (this.category_data?.parent_slug && this.category_data?.parent_name) {
			breadcrumbs.push({
				name: this.category_data.parent_name,
				url: siteUrl + 'experience/' + this.category_data.parent_slug,
			});
		}
		breadcrumbs.push({ name: pageName, url: this.pageUrl });

		const extraNodes: any[] = [];
		const videoContentUrl = (this.category_data?.video_url || '').toString().trim()
			|| (this.category_data?.video && this.category_image_url
				? (this.category_image_url + this.category_data.video)
				: '');
		const uploadDate = (this.category_data?.updated_at || this.category_data?.created_at || '')
			.toString().trim().slice(0, 10) || undefined;
		const videoNode = this.mainService.buildVideoObject({
			name: pageName,
			contentUrl: videoContentUrl || undefined,
			thumbnailUrl: imageUrl,
			uploadDate,
			description,
		});
		if (videoNode) {
			extraNodes.push(videoNode);
		}

		this.mainService.updateCollectionPageSchema({
			pageUrl: this.pageUrl,
			name: pageName,
			description,
			image: imageUrl,
			breadcrumbs,
			items: listing,
			totalItems: this.totalRecord,
			faqs: this.experienceFaqs,
			itemNameKey: 'title',
			itemUrlBuilder: (item) => item?.slug ? (siteUrl + 'experiences/' + item.slug) : undefined,
			extraNodes,
		});
	}

	private createBreadcrumbs(
		route: ActivatedRoute,
		url: string = '',
		breadcrumbs: Array<{ label: string, url: string, path: any }> = []): Array<{ label: string, url: string, path: any }> {

		const children: ActivatedRoute[] = route.children;

		if (children.length === 0) {
			return breadcrumbs;
		}

		for (const child of children) {
			const paths = child.snapshot.url.map(segment => segment.path);
			const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
			if (routeURL !== '') {
				url += `/${routeURL}`;
			}

			breadcrumbs.push({ label: child.snapshot.paramMap.get('slug'), url: url, path: paths });
			return this.createBreadcrumbs(child, url, breadcrumbs);
		}

		return breadcrumbs;
	}

	changeView() {
		this.gridView = !this.gridView;
	}

	updateUrlParams() {
		// const url = '/experience/' + [this.slug, this.country_slug, this.state_slug]
		// 	.filter(Boolean)
		// 	.join('/');
		// this._location.replaceState(url + "?date=" + this.selected_date + "&page=" + this.page + "&exp_pos=" + ((this.page * 9) - 5) + "&is_booking=" + this.is_booking);
	}

	handlePageChange(page: any) {
		this.page = page;
		this.bridgeService.setPage(page);
		const pageSlug = this.page != 1 ? `page-${this.page}` : null;
		const url = '/experience/' + [this.slug, this.country_slug, this.state_slug, pageSlug].filter(Boolean).join('/');

		let queryParams: any = {};
		if (this.is_booking > 0) {
			queryParams.is_booking = this.is_booking;
		}
		if (this.start_date) {
			queryParams.start_date = this.start_date;
		}
		if (this.end_date) {
			queryParams.end_date = this.end_date;
		}
		if (this.selected_date) {
			queryParams.date = this.selected_date;
		}
		if (this.badge_id) {
			queryParams.badge_id = String(this.badge_id);
		}
		if (this.order_by) {
			queryParams.order_by = this.order_by;
			if (this.order) {
				queryParams.order = this.order;
			}
		}
		this.is_offset = 0;
		this.canonicalService.replaceStateWithFilters(this._location, url, queryParams);
		this.getAllExperienceData();
	}

	pauseSwiper(): void {
		if (!this.showCategoryCarouselControls) {
			return;
		}
		const swiper = this.swiperEl()?.nativeElement?.swiper;
		swiper?.autoplay?.stop();
	}

	resumeSwiper(): void {
		if (!this.showCategoryCarouselControls) {
			return;
		}
		const swiper = this.swiperEl()?.nativeElement?.swiper;
		swiper?.autoplay?.start();
	}

	/** slidesPerView for the current viewport, matching `breakpoints`. */
	getCategorySlidesPerView(): number {
		if (!this.isBrowser) {
			return this.breakpoints[992].slidesPerView;
		}
		const width = window.innerWidth;
		if (width >= 992) {
			return this.breakpoints[992].slidesPerView;
		}
		if (width >= 768) {
			return this.breakpoints[768].slidesPerView;
		}
		if (width >= 575) {
			return this.breakpoints[575].slidesPerView;
		}
		return this.breakpoints[0].slidesPerView;
	}

	/** Show nav/autoplay only when there are more slides than visible at the current breakpoint. */
	updateCategoryCarouselControls(): void {
		const count = this.categoryList?.length ?? 0;
		this.showCategoryCarouselControls = count > this.getCategorySlidesPerView();
	}

	slideNext(slider: string) {
		if (slider === 'swiperEl') {
			const swiper = this.swiperEl()?.nativeElement?.swiper;
			swiper.slideNext()
		} else {
			console.error('Invalid slider identifier');
		}
	}

	slidePrev(slider: string) {
		if (slider === 'swiperEl') {
			const swiper = this.swiperEl()?.nativeElement?.swiper;
			swiper.slidePrev()
		} else {
			console.error('Invalid slider identifier');
		}
	}

	scrollToSelectedExperience() {
		if (this.isBrowser) {
			const expId = sessionStorage.getItem('selected_exp_id');
			if (!expId) return;
			const element = document.getElementById('exp-' + expId);
			if (element) {
				element.scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
				sessionStorage.removeItem('selected_exp_id');
			}
		}

	}

	readUrl() {
		if (this.isBrowser) {
			const path = window.location.pathname;
			const segments = path.split('/').filter(segment => segment.length > 0);

			if (segments.length >= 2) {
				const category = segments[1];
				const country = segments[2];
			}
			const experienceIndex = segments.indexOf('experience');
			if (experienceIndex !== -1) {
				const dynamicSegments = segments.slice(experienceIndex + 1);
			}
		}
	}

	/**
	 * Read slug / location / page from the URL (and parent :slug) so pagination
	 * links can be written in the constructor — same timing as location-region.
	 */
	private applyPaginationStateFromUrl(): void {
		const parts = (this.router?.url || '').split('?')[0].split('/').filter(Boolean);
		const expIdx = parts.indexOf('experience');
		if (expIdx < 0) {
			this.ensureRouteSlug();
			return;
		}
		const after = parts.slice(expIdx + 1);
		if (after.length === 0) {
			this.ensureRouteSlug();
			return;
		}
		const last = after[after.length - 1];
		const hasPage = last?.startsWith('page-');
		if (hasPage) {
			this.page = parseInt(last.replace('page-', ''), 10) || 1;
			this.bridgeService.setPage(this.page);
			after.pop();
		}
		if (after[0] && !after[0].startsWith('page-')) {
			this.slug = after[0];
			this.bridgeService.setSlug(this.slug);
		}
		if (after[1]) {
			this.country_slug = after[1];
			this.bridgeService.setCountrySlug(this.country_slug);
		}
		if (after[2]) {
			this.state_slug = after[2];
			this.bridgeService.setState(this.state_slug);
		}
		this.ensureRouteSlug();
	}

	/** Parent route owns :slug (experience/:slug); child params may omit it. */
	private ensureRouteSlug(): void {
		if (this.slug) {
			return;
		}
		const parentSlug = this.activatedRoute.parent?.snapshot?.paramMap?.get('slug');
		if (parentSlug) {
			this.slug = parentSlug;
			this.bridgeService.setSlug(this.slug);
			return;
		}
		const parts = (this.router?.url || '').split('?')[0].split('/').filter(Boolean);
		const expIdx = parts.indexOf('experience');
		if (expIdx >= 0 && parts[expIdx + 1] && !parts[expIdx + 1].startsWith('page-')) {
			this.slug = parts[expIdx + 1];
			this.bridgeService.setSlug(this.slug);
		}
	}

	setPaginationLinks(): void {
		this.ensureRouteSlug();
		if (!this.slug) {
			return;
		}
		const url = 'experience/' + [this.slug, this.country_slug, this.state_slug, `page-`].filter(Boolean).join('/');
		const baseUrl = String(this.siteUrl || '') + url;
		if (this.page > 1) {
			const prevUrl = this.normalizeUrl(baseUrl + (this.page - 1));
			if (this.page > 2) {
				this.canonicalService.setPrev(prevUrl);
			} else {
				const listUrl = 'experience/' + [this.slug, this.country_slug, this.state_slug].filter(Boolean).join('/');
				this.canonicalService.setPrev(String(this.siteUrl || '') + listUrl);
			}
			const canonicalUrl = String(this.siteUrl || '') + 'experience/' + [this.slug, this.country_slug, this.state_slug].filter(Boolean).join('/');
			this.canonicalService.setCanonical(this.normalizeUrl(canonicalUrl));
		} else {
			this.canonicalService.removePrev();
		}
		if (this.last_page > 0 && this.page < this.last_page) {
			const nextUrl = this.normalizeUrl(baseUrl + (this.page + 1));
			this.canonicalService.setNext(nextUrl);
		} else {
			this.canonicalService.removeNext();
		}
	}
}
